/**
 * Show listing DPE detail (unfolded scale & additional information) after clicking on "Voir le détail" button
 * ⚠️ Only on Desktop
 */
export function initializeListingDetailButton() {
    const showDetailButton = document.querySelector('[data-listing-show-dpe-detail-button]');

    if (showDetailButton) {
        showDetailButton.addEventListener('click', e => {
            e.currentTarget.classList.add('hide');
            document.querySelector('[data-dpe-unfolded-block]').classList.remove('hide');
            document.querySelector('[data-ges-unfolded-block]').classList.remove('hide');
            document.querySelector('[data-dpe-additional-info]').classList.remove('hide');
        });
    }
}
